(() => {
  const STORAGE_KEY = "fivefourfive:last-viewed";
  const MAX_ITEMS = 5;

  const read = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  };

  const write = (items) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {
      // no-op
    }
  };

  const trackCurrentProduct = () => {
    const node = document.getElementById("RecentlyViewed545Product");
    if (!node) return;

    try {
      const product = JSON.parse(node.textContent || "{}");
      if (!product || !product.url) return;

      const items = read().filter((item) => item.url !== product.url);
      items.unshift(product);
      write(items);
    } catch (e) {
      // no-op
    }
  };

  const buildCard = (item) => {
    const itemEl = document.createElement("div");
    itemEl.className = "cart-545__recent-item";

    const media = document.createElement("div");
    media.className = "cart-545__recent-media";

    const link = document.createElement("a");
    link.className = "cart-545__recent-link";
    link.href = item.url;

    if (item.image) {
      const img = document.createElement("img");
      img.className = "cart-545__recent-image";
      img.src = item.image;
      img.alt = item.title || "";
      img.loading = "lazy";
      link.appendChild(img);
    }

    const price = document.createElement("span");
    price.className = "cart-545__recent-price";
    price.textContent = item.price || "";
    media.appendChild(price);

    const add = document.createElement("button");
    add.type = "button";
    add.className = "cart-545__recent-add";
    add.setAttribute("aria-label", `Add ${item.title || "product"} to cart`);
    add.dataset.cart545RecentAdd = "";
    add.dataset.variantId = String(item.directVariantId || "");
    add.innerHTML = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path d="M8 2V14M2 8H14" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="square"/></svg>';

    media.appendChild(link);
    media.appendChild(add);
    itemEl.appendChild(media);
    return itemEl;
  };

  const buildSectionCard = (item) => {
    const li = document.createElement("li");
    li.className = "grid__item";

    const card = document.createElement("div");
    card.className = "card-545 is-single";

    const media = document.createElement("div");
    media.className = "card-545__media ratio";
    media.style.setProperty("--ratio-percent", "132%");

    const track = document.createElement("div");
    track.className = "card-545__track";

    const slide = document.createElement("a");
    slide.className = "card-545__slide is-single";
    slide.href = item.url || "#";

    if (item.image) {
      const img = document.createElement("img");
      img.className = "card-545__img";
      img.src = item.image;
      img.alt = item.title || "";
      img.loading = "lazy";
      slide.appendChild(img);
    }

    track.appendChild(slide);
    media.appendChild(track);

    const cover = document.createElement("a");
    cover.className = "card-545__cover";
    cover.href = item.url || "#";

    if (item.image) {
      const coverImg = document.createElement("img");
      coverImg.className = "card-545__cover-img";
      coverImg.src = item.image;
      coverImg.alt = item.title || "";
      coverImg.loading = "lazy";
      cover.appendChild(coverImg);
    }

    media.appendChild(cover);
    card.appendChild(media);

    const info = document.createElement("div");
    info.className = "card-545__info";

    const title = document.createElement("h3");
    title.className = "card-545__title";
    const titleLink = document.createElement("a");
    titleLink.href = item.url || "#";
    titleLink.textContent = item.title || "";
    title.appendChild(titleLink);

    const price = document.createElement("div");
    price.className = "card-545__price";
    price.textContent = item.price || "";

    info.appendChild(title);
    info.appendChild(price);

    if (item.color) {
      const color = document.createElement("div");
      color.className = "card-545__color";
      color.textContent = item.color;
      info.appendChild(color);
    }

    card.appendChild(info);
    li.appendChild(card);
    return li;
  };

  const render = (root = document) => {
    const container = root.querySelector("[data-cart-545-recent-track]");
    const section = root.querySelector("[data-cart-545-recent]");
    if (!container || !section) return;

    const items = read().filter((item) => Number(item.variantCount) === 1 && item.directVariantId);
    container.innerHTML = "";

    if (!items.length) {
      section.setAttribute("hidden", "");
      return;
    }

    items.forEach((item) => {
      container.appendChild(buildCard(item));
    });

    section.removeAttribute("hidden");
  };

  const renderSections = (root = document) => {
    root.querySelectorAll("[data-last-viewed-545]").forEach((section) => {
      const grid = section.querySelector("[data-last-viewed-545-grid]");
      if (!grid) return;

      const currentUrl = section.getAttribute("data-current-url") || "";
      const limit = parseInt(section.getAttribute("data-limit") || "4", 10);
      const items = read()
        .filter((item) => item.url && item.url !== currentUrl)
        .slice(0, limit);

      grid.innerHTML = "";

      if (!items.length) {
        section.setAttribute("hidden", "");
        return;
      }

      items.forEach((item) => {
        grid.appendChild(buildSectionCard(item));
      });

      section.removeAttribute("hidden");
    });
  };

  window.FIVEFOURFIVE_RECENTLY_VIEWED = {
    read,
    render,
    renderSections
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      trackCurrentProduct();
      render(document);
      renderSections(document);
    });
  } else {
    trackCurrentProduct();
    render(document);
    renderSections(document);
  }
})();
